import { React, useState, useEffect, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import {
  Tooltip,
  Button,
  Row,
  Col,
  Form,
  Input,
  PageHeader,
  Radio,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import "antd-country-phone-input/dist/index.css";
import "flagpack/dist/flagpack.css";
import { Switch } from "antd";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import { GlobalSet, Styled } from "../../pageStyled";
import AddNewGrade from "../QualityGradeDrawer/addNewGrade";
import AddQuality from "../QualityGradeDrawer/addQuality";
import EditDeleteGrade from "../QualityGradeDrawer/editDeleteGrade";
import trusted from "../../../Assets/Icons/trusted.png";
import {
  setOrderType,
  getMachineGradeSelectForConfig,
} from "../../../Services/settingsServices";
import alertYellow from "../../../Assets/Icons/alertYellow.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import ReelOrderSpecDrawer from "./reelOrderSpecDrawer";
import SheetOrderSpecDrawer from "./sheetOrderSpecDrawer";
import OrderToleranceDrawer from "./orderToleranceDrawer";

const ConfigGlobalSettings = (props) => {
  // const [switchCase, setSwitchCase] = useState();
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [switchTooltip, setSwitchTooltip] = useState(true);
  const [switchTooltipSheet, setSwitchTooltipSheet] = useState(true);
  const [switchTooltipKraft, setSwitchTooltipKraft] = useState(true);
  const [switchTooltipDuplex, setSwitchTooltipDuplex] = useState(false);
  const [switchTooltipWriting, setSwitchTooltipWriting] = useState(true);
  const [NewGradeSideDrawer, setNewGradeSideDrawer] = useState(false);
  const [AddQualitySideDrawer, setAddQualitySideDrawer] = useState(false);
  const [EditDeleteGradeSideDrawer, setEditDeleteGradeSideDrawer] =
    useState(false);
  const [modalPopupData, setModalPopupData] = useState();
  const [settings, setSettings] = useState();
  const [selectedGrade, setSelectedGrade] = useState();
  const [newGrade, setNewGrade] = useState();
  const toggleRef = useRef();
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [roles, setRoles] = useState({});
  const [alert, setAlert] = useState(false);
  const [newGradeAlert, setNewGradeAlert] = useState(false);
  const [deleteGradeAlert, setDeleteGradeAlert] = useState(false);
  const [gradeAlert, setGradeAlert] = useState(false);
  const [modifiedGrade, setModifiedGrade] = useState();
  const [deleteGradeResponse, setDeleteGradeResponse] = useState();
  const [rendering, setRendering] = useState(true);
  const [reelOrderSideDrawer, setReelOrderSideDrawer] = useState(false);
  const [sheetOrderSideDrawer, setSheetOrderSideDrawer] = useState(false);
  const [orderToleranceSideDrawer, setOrderToleranceSideDrawer] =
    useState(false);
  const [switchTooltipOderTolerance, setSwitchTooltipOrderTolerance] =
    useState(false);
  const [orderWindowType, setOrderWindowType] = useState();
  const windowTypeOptions = [
    { label: "Fixed Period", value: "fixed" },
    { label: "Flexible ", value: "flexible" },
  ];
  const [cutoffWindowType,setCutoffWindowType] = useState();
  const [poSwitch, setPOSwitch] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    if (rendering) {
      fetchSettings();
      setRendering(false);
    }
    setRoles(userDetails.roles.global_settings);
  }, [rendering]);

  useEffect(() => {
    loadValues();
  }, [settings]);

  const fetchSettings = async () => {
    const resp = await getMachineGradeSelectForConfig();
    if (!resp.error) {
      // console.log("settings", resp);
      setSettings(resp.data.data.settings);
      setOrderWindowType(resp.data.data.settings.order_window_type);
      setCutoffWindowType(resp.data.data.settings.order_cutoff_type);
    setPOSwitch(resp.data.data.settings.po_unique);
    }
  };
  const handleOrderWindowTypeChange = async (e) => {
   
    try {
      const resp = await setOrderType({ order_window_type: e.target.value });
      if (!resp.error) {
         setOrderWindowType(e.target.value);
      }
    } catch (err) {
      console.log("Error in order type", err);
      if(err?.response?.status == 500){
        setErrorMessage("Something went wrong. Please try again");
        } else{
          setErrorMessage(err.response.data?.msg);
        }
        setTimeout(() => {
        setError(false);
        }, 3000);
      };
  };
  const handleCutoffWindowTypeChange = async (e) => {
   
    try {
      const resp = await setOrderType({ order_cutoff_type: e.target.value });
      if (!resp.error) {
         setCutoffWindowType(e.target.value);
      }
    } catch (err) {
      console.log("Error in order type", err);
      setError(true);
      if(err?.response?.status == 500){
        setErrorMessage("Something went wrong. Please try again");
        } else{
          setErrorMessage(err.response.data?.msg);
        }
        setTimeout(() => {
        setError(false);
        }, 3000);
      };
  };

  const updateOrderWindow = async (e) => {
    try {
      const resp = await setOrderType({ order_window: e.target.value });
      if (!resp.error) {
        //
      }
    } catch (err) {
      setError(true);
      console.log("Error in order type", err);
      if(err?.response?.status == 500){
        setErrorMessage("Something went wrong. Please try again");
        } else{
          setErrorMessage(err.response.data?.msg);
        }
        setTimeout(() => {
        setError(false);
        }, 3000);
      };
    }
 
  const updateCutoffWindow = async (e) => {
    try {
      const resp = await setOrderType({ cutoff_period: e.target.value });
      if (!resp.error) {
        //
      }
    } catch (err) {
      setError(true);
      console.log("Error in order type", err);
      if(err?.response?.status == 500){
        setErrorMessage("Something went wrong. Please try again");
        } else{
          setErrorMessage(err.response.data?.msg);
        }
        setTimeout(() => {
        setError(false);
        }, 3000);
      };
    
  };


   const updatePO = async (e) => {
    setPOSwitch(e);
    try {
      const resp = await setOrderType({ po_unique: e});
      if (resp.error) {
        //
        setPOSwitch(!poSwitch);
      }
    } catch (err) {
      setPOSwitch(!poSwitch);
      setError(true);
      console.log("Error in order type", err);
      if(err?.response?.status == 500){
        setErrorMessage("Something went wrong. Please try again");
        } else{
          setErrorMessage(err.response.data?.msg);
        }
        setTimeout(() => {
        setError(false);
        }, 3000);
      };
    }


  const loadValues = () => {
    if (settings) {
      const reel = settings.order_types.filter((type) => {
        return type.name === "reel";
      });
      setSwitchTooltip(reel[0].value);
      const sheet = settings.order_types.filter((type) => {
        return type.name === "sheet";
      });
      setSwitchTooltipSheet(sheet[0].value);
      const orderTolerance = settings.order_types.filter((type) => {
        return type.name === "tolerances";
      });
      setSwitchTooltipOrderTolerance(orderTolerance[0].value);
    }
  };

  const onOpenReelOrderDrawer = () => {
    setReelOrderSideDrawer(true);
  };

  const onCloseReelOrderDrawer = () => {
    setReelOrderSideDrawer(false);
  };

  const onCloseOrderToleranceDrawer = () => {
    setOrderToleranceSideDrawer(false);
  };

  const onOpenSheetOrderDrawer = () => {
    setSheetOrderSideDrawer(true);
  };

  const onCloseSheetOrderDrawer = () => {
    setSheetOrderSideDrawer(false);
    setRendering(true);
  };

  const showAlert = () => {
    setAlert(true);
    setTimeout(() => setAlert(false), 2000);
  };

  const showNewGradeAlert = () => {
    setNewGradeAlert(true);
    setTimeout(() => setNewGradeAlert(false), 2000);
  };

  const showDeleteGradeAlert = () => {
    setDeleteGradeAlert(true);
    setTimeout(() => setDeleteGradeAlert(false), 2000);
  };

  const showGradeAlert = (value) => {
    setModifiedGrade(value);
    setGradeAlert(true);
    setTimeout(() => {
      setGradeAlert(false);
      setModifiedGrade();
    }, 2000);
  };

  const handleSwitchChange = (checked) => {
    if (!switchTooltipSheet && !checked) {
      // console.log("Can't disable both order types");
      showAlert();
    } else {
      if (checked === false) {
        setModalPopupData({
          title: "Disable reel orders?",
          content:
            "You cannot add reel orders if disabled. Are you sure you want to continue?",
          image: warning,
          key: "Reel",
          data: checked,
        });
        modalShow();
      } else {
        setModalPopupData({
          title: "Enable reel orders?",
          content:
            "You can add reel orders if enabled. Are you sure you want to continue?",
          image: trusted,
          key: "Reel",
          data: checked,
        });
        modalShow();
      }
    }
  };

  const handleSwitchChangeSheet = (checked) => {
    if (!switchTooltip && !checked) {
      // console.log("Can't disable both order types");
      showAlert();
    } else {
      if (checked === false) {
        setModalPopupData({
          title: "Disable Sheet orders?",
          content:
            "You cannot add sheet orders if disabled. Are you sure you want to continue?",
          image: warning,
          key: "Sheet",
          data: checked,
        });
        modalShow();
      } else {
        setModalPopupData({
          title: "Enable Sheet orders?",
          content:
            "You can add sheet orders if enabled. Are you sure you want to continue?",
          image: trusted,
          key: "Sheet",
          data: checked,
        });
        modalShow();
      }
    }
  };

  const handleSwitchChangeKraft = (checked, grade) => {
    // console.log("Toggle ref", checked, grade);
    if (checked === false) {
      setModalPopupData({
        title: "Disable grade?",
        content:
          "Product cannot be created for a disabled grade. Are you sure you want to continue?",
        image: warning,
        key: "kraft",
        data: checked,
        currentGrade: grade,
      });
      modalShow();
    } else {
      setModalPopupData({
        title: "Enable grade?",
        content:
          "Products can be created for the enabled grades. Are you sure you want to continue?",
        image: trusted,
        key: "kraft",
        data: checked,
        currentGrade: grade,
      });
      modalShow();
    }
  };

  const addGrade = (newGrade) => {
    let tempArray = settings.grades;
    tempArray.push(newGrade);
    setSettings({ ...settings, grades: tempArray });
  };

  const modalShow = () => {
    setIsVisibleModal(true);
  };

  const modalClose = () => {
    setIsVisibleModal(false);
  };

  const modalConfirm = async () => {
    setIsVisibleModal(false);
    if (modalPopupData.key === "kraft") {
      const requestBody = {
        grade: modalPopupData.currentGrade.name,
        value: modalPopupData.data,
      };
      try {
        const resp = await setOrderType(requestBody);
        if (!resp.error) {
          fetchSettings();
          showGradeAlert(requestBody);
        }
      } catch (err) {
        console.log("Error in order type", err);
        setError(true);
        if(err?.response?.status == 500){
          setErrorMessage("Something went wrong. Please try again");
          } else{
            setErrorMessage(err.response.data?.msg);
          }
          setTimeout(() => {
          setError(false);
          }, 3000);
        };
    }
    if (modalPopupData.key === "Reel") {
      const requestBody = {
        order_types: {
          name: "reel",
          value: modalPopupData.data,
        },
      };
      try {
        const resp = await setOrderType(requestBody);
        if (!resp.error) {
          setSwitchTooltip(modalPopupData.data);
        }
      } catch (err) {
        console.log("Error in order type", err);
        setError(true);
        if(err?.response?.status == 500){
          setErrorMessage("Something went wrong. Please try again");
          } else{
            setErrorMessage(err.response.data?.msg);
          }
          setTimeout(() => {
          setError(false);
          }, 3000);
        }
    }
    if (modalPopupData.key === "Sheet") {
      const requestBody = {
        order_types: {
          name: "sheet",
          value: modalPopupData.data,
        },
      };
      try {
        const resp = await setOrderType(requestBody);
        if (!resp.error) {
          setSwitchTooltipSheet(modalPopupData.data);
        }
      } catch (err) {
        console.log("Error in order type", err);
        setError(true);
        if(err?.response?.status == 500){
          setErrorMessage("Something went wrong. Please try again");
          } else{
            setErrorMessage(err.response.data?.msg);
          }
          setTimeout(() => {
          setError(false);
          }, 3000);
        }
    }
    if (modalPopupData.key === "Duplex") {
      setSwitchTooltipDuplex(modalPopupData.data);
    }
    if (modalPopupData.key === "Writing") {
      setSwitchTooltipWriting(modalPopupData.data);
    }
    if (modalPopupData.key === "Tolerance") {
      const requestBody = {
        order_types: {
          name: "tolerances",
          value: modalPopupData.data,
        },
      };
      try {
        const resp = await setOrderType(requestBody);
        if (!resp.error) {
          setSwitchTooltipOrderTolerance(modalPopupData.data);
        }
      } catch (err) {
        console.log("Error in order type", err);
        setError(true);
        if(err?.response?.status == 500){
          setErrorMessage("Something went wrong. Please try again");
          } else{
            setErrorMessage(err.response.data?.msg);
          }
          setTimeout(() => {
          setError(false);
          }, 3000);
        };
    setModalPopupData();
  };
 }

  const showNewGradeDrawer = () => {
    setNewGradeSideDrawer(true);
  };
  const onCloseFullNewGrade = () => {
    setNewGradeSideDrawer(false);
  };
  const onCloseNewGrade = (name, alias) => {
    setNewGrade({ name: name, alias: alias });
    setNewGradeSideDrawer(false);
    showNewGradeAlert();
    setRendering(true);
  };

  const addNewGradeSuccess = (name, alias) => {
    const grade = { name: name, alias: alias };
    setNewGrade(grade);
    setNewGradeSideDrawer(false);
    setAddQualitySideDrawer(true);
  };

  const onCloseAddQuality = () => {
    setAddQualitySideDrawer(false);
    setRendering(true);
  };

  const showEditDeleteGradeDrawer = (grade) => {
    setSelectedGrade(grade);
    setEditDeleteGradeSideDrawer(true);
    setRendering(true);
  };

  const onCloseEditDeleteGrade = () => {
    setEditDeleteGradeSideDrawer(false);
    setRendering(true);
  };

  const onCloseDeleteGrade = (response) => {
    setEditDeleteGradeSideDrawer(false);
    setDeleteGradeResponse(response);
    showDeleteGradeAlert();
    setRendering(true);
  };

  const onOpenOrderToleranceDrawer = () => {
    setOrderToleranceSideDrawer(true);
  };

  const handleOderTolerance = (checked) => {
    if (checked === false) {
      setModalPopupData({
        title: "Disable order Tolerance?",
        content:
          "The orders will be fulfilled without any the tolerance range. Are you sure you want to continue?",
        image: warning,
        key: "Tolerance",
        data: checked,
      });
      modalShow();
    } else {
      setModalPopupData({
        title: "Enable order Tolerance?",
        content:
          "The orders will be fulfilled within the tolerance range. You can configure the tolerance limits in the settings. Are you sure you want to continue?",
        image: trusted,
        key: "Tolerance",
        data: checked,
      });
      modalShow();
    }
    // setSwitchTooltipOrderTolerance(checked);
  };

  return settings ? (
    <RightLayoutContainer className="globalset">
      <PageTitleComp>
        <PageHeader
          ghost={false}
          title="Global Settings"
          // extra={[
          //     <Button key="3" className="textTypeBtn">Cancel changes</Button>,
          //     <Button key="2" className="themeBtn"><Iconmoon icon="addcircle" size={14} color="#ffffff" />Save</Button>,
          //     <Button key="1" className="themeBtn"><Iconmoon icon="edit" size={14} color="#ffffff" />Edit</Button>,
          // ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form name="basic" autoComplete="off" className="haberLogin">
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Order Types</h2>
                    <p>The mill can produce enabled order types</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Reel Order</label>
                        <p>
                          The reel orders will be recorded only if it’s enabled
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                            <Tooltip
                              className="edit-tooltip"
                              placement="bottomRight"
                              title={
                                "Configure reel and core dia for reel orders"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Button
                                key="3"
                                className="textTypeBtn edit-btn"
                                onClick={onOpenReelOrderDrawer}
                              >
                                <Iconmoon
                                  icon={"setting"}
                                  size={16}
                                  color="#605E5C"
                                />
                              </Button>
                            </Tooltip>
                            <Tooltip
                              placement="bottomRight"
                              title={
                                roles.edit
                                  ? switchTooltip
                                    ? "Disable accepting reel orders"
                                    : "Enable accepting reel orders"
                                  : switchTooltip
                                  ? "Reel orders can be accepted"
                                  : "Reel orders can't be accepted"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Switch
                                checked={switchTooltip}
                                onChange={handleSwitchChange}
                                className="switch-new"
                                disabled={!roles.edit}
                              />
                            </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Sheet Order</label>
                        <p>
                          The sheet orders will be recorded only if it’s enabled
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                            <Tooltip
                              className="edit-tooltip"
                              placement="bottomRight"
                              title={
                                "Configure grain preference for sheet orders"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Button
                                key="3"
                                className="textTypeBtn edit-btn"
                                onClick={onOpenSheetOrderDrawer}
                              >
                                <Iconmoon
                                  icon={"setting"}
                                  size={16}
                                  color="#605E5C"
                                />
                              </Button>
                            </Tooltip>
                            <Tooltip
                              placement="bottomRight"
                              title={
                                roles.edit
                                  ? switchTooltipSheet
                                    ? "Disable accepting sheet orders"
                                    : "Enable accepting sheet orders"
                                  : switchTooltipSheet
                                  ? "Sheet orders can be accepted"
                                  : "Sheet orders can't be accepted"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Switch
                                checked={switchTooltipSheet}
                                onChange={handleSwitchChangeSheet}
                                className="switch-new"
                                disabled={!roles.edit}
                              />
                            </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Tolerance</label>
                        <p>
                          The orders will be processed within the tolerance
                          range if it is enabled
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                            <Tooltip
                              className="edit-tooltip"
                              placement="bottomRight"
                              title={"Configure tolerance for orders"}
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Button
                                key="3"
                                className="textTypeBtn edit-btn"
                                onClick={onOpenOrderToleranceDrawer}
                              >
                                <Iconmoon
                                  icon={"setting"}
                                  size={16}
                                  color="#605E5C"
                                />
                              </Button>
                            </Tooltip>
                            <Tooltip
                              placement="bottomRight"
                              title={
                                switchTooltipOderTolerance
                                  ? "Enable order tolerance"
                                  : "Disable order tolerance"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Switch
                                checked={switchTooltipOderTolerance}
                                onChange={handleOderTolerance}
                                className="switch-new"
                                // disabled={!roles.edit}
                              />
                            </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Grade Types</h2>
                    <p>The mill can produce enabled grades</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  {settings.grades?.map((grade) => {
                    return (
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>
                              {grade.name} - <span> {grade.alias}</span>
                            </label>
                            <p>
                              {`The ${grade.alias} grade orders will only be recorded if it’s
                                    enabled`}
                            </p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <GlobalSet>
                              <Styled>
                                <Tooltip
                                  className="edit-tooltip"
                                  placement="bottomRight"
                                  title={
                                    roles.edit
                                      ? "Modify this grade"
                                      : "View this grade"
                                  }
                                  getPopupContainer={(triggerNode) =>
                                    triggerNode
                                  }
                                >
                                  <Button
                                    key="3"
                                    className="textTypeBtn edit-btn"
                                    onClick={() =>
                                      showEditDeleteGradeDrawer(grade)
                                    }
                                  >
                                    <Iconmoon
                                      icon={roles.edit ? "edit" : "file-view"}
                                      size={16}
                                      color="#605E5C"
                                    />
                                  </Button>
                                </Tooltip>
                                <Tooltip
                                  placement="bottomRight"
                                  title={
                                    roles.edit
                                      ? grade.value
                                        ? `Disable accepting orders of ${grade.alias} grade`
                                        : `Enable accepting orders of ${grade.alias} grade`
                                      : grade.value
                                      ? `Orders for ${grade.alias} grade can be accepted`
                                      : `Orders for ${grade.alias} grade can't be accepted`
                                  }
                                  getPopupContainer={(triggerNode) =>
                                    triggerNode
                                  }
                                >
                                  <Switch
                                    ref={toggleRef}
                                    checked={grade.value}
                                    onChange={(e) =>
                                      handleSwitchChangeKraft(e, grade)
                                    }
                                    className="switch-new"
                                    disabled={!roles.edit}
                                  />
                                </Tooltip>
                              </Styled>
                            </GlobalSet>
                          </div>
                        </Col>
                      </Row>
                    );
                  })}
                  {roles.edit && (
                    <Row className="centerAlign">
                      <Col span={12}>
                        <GlobalSet>
                          <div className="boxFieldTitle">
                            <Button
                              key="3"
                              className="textTypeBtn textBtnIcon"
                              onClick={showNewGradeDrawer}
                            >
                              <Iconmoon
                                icon="addcircle"
                                size={16}
                                color="#EA655B"
                              />
                              Add a new grade
                            </Button>
                          </div>
                        </GlobalSet>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Other Details</h2>
                    <p>All other settings applicable to your mill production</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Order Window Type</label>
                        <p style={{paddingRight:"20px"}}>
                          Defines the default period for order eligibility in
                          deckle matching
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType switchRadio rightAlign">
                        <Form.Item
                          name="order_window_type"
                          rules={[
                            {
                              required: true,
                              message: "Please select an option",
                            },
                          ]}
                          className=""
                          initialValue={settings.order_window_type}
                        >
                          <Radio.Group
                            optionType="button"
                            buttonStyle="solid"
                            defaultValue="fixed"
                            options={windowTypeOptions}
                            onChange={handleOrderWindowTypeChange}
                            disabled={!roles.edit}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                 {orderWindowType === "fixed" && <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Order Window</label>
                        <p style={{paddingRight:"20px"}}>
                          Number of days for which orders will be automatically
                          selected in every deckle match
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="order_window"
                          rules={[
                            {
                              pattern: /^\+?\d+$/,
                              message:
                                "Only positive integers can be added here",
                            },
                          ]}
                          className=""
                          initialValue={settings.order_window}
                        >
                          <Input
                            defaultValue="1"
                            onChange={updateOrderWindow}
                            disabled={!roles.edit}
                            placeholder="Enter the number of days"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>}
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Order Cutoff Type</label>
                        <p style={{paddingRight:"20px"}}>
                          Defines the default period after which orders won't be available for
                          deckle match
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType switchRadio rightAlign">
                        <Form.Item
                          name="cutoff_window_type"
                          rules={[
                            {
                              required: true,
                              message: "Please select an option",
                            },
                          ]}
                          className=""
                          initialValue={settings.order_cutoff_type}
                        >
                          <Radio.Group
                            optionType="button"
                            buttonStyle="solid"
                            defaultValue="fixed"
                            options={windowTypeOptions}
                            onChange={handleCutoffWindowTypeChange}
                            disabled={!roles.edit}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                 {cutoffWindowType === "fixed" && <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Cutoff Period</label>
                        <p style={{paddingRight:"20px"}}>
                          Orders created before this date won't be available for deckle match
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="cutoff_period"
                          rules={[
                            {
                              pattern: /^\+?\d+$/,
                              message:
                                "Only positive integers can be added here",
                            },
                          ]}
                          className=""
                          initialValue={settings.cutoff_period}
                        >
                          <Input
                            defaultValue="1"
                            onChange={updateCutoffWindow}
                            disabled={!roles.edit}
                            placeholder="Enter the number of days"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>}
                   <Row className="centerAlign">
                                      <Col span={12}>
                                        <div className="boxFieldTitle">
                                          <label>Purchase Order Uniqueness</label>
                                          <p>
                                            Purchase orders can be same for different customers.
                                          </p>
                                        </div>
                                      </Col>
                                      <Col span={12}>
                                        <div className="boxFormType">
                                          <GlobalSet>
                                            <Styled>
                                              <Tooltip
                                                placement="bottomRight"
                                                title={!poSwitch ? "Enable Purchase Order Uniqueness" : "Disable Purchase Order Uniqueness"
                                                }
                                                getPopupContainer={(triggerNode) => triggerNode}
                                              >
                                                <Switch
                                                  checked={poSwitch}
                                                  onChange={updatePO}
                                                  className="switch-new"
                                                   disabled={!roles.edit}
                                                />
                                              </Tooltip>
                                            </Styled>
                                          </GlobalSet>
                                        </div>
                                      </Col>
                                    </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>

      {newGradeAlert && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={` A new grade ${newGrade.name} is successfully added`}
        />
      )}

      {deleteGradeAlert && (
        <AlertContainer
          color={`${deleteGradeResponse.error ? "red" : "green"} toaster`}
          icon={deleteGradeResponse.error ? alertRed : alertGreen}
          msg={
            deleteGradeResponse.error
              ? deleteGradeResponse.msg
              : `The grade ${selectedGrade.name} is successfully deleted`
          }
        />
      )}

      {alert && (
        <AlertContainer
          color="red toaster"
          icon={alertYellow}
          msg="Both order types - Reels and Sheets cannot be disabled"
        />
      )}

      {gradeAlert && (
        <AlertContainer
          color="green toaster"
          icon={alertYellow}
          msg={`${modifiedGrade.grade} grade is ${
            modifiedGrade.value ? "enabled" : "disabled"
          } `}
        />
      )}

      <ModalPopup visible={isVisibleModal}>
        <div className="Popup-img">
          <img src={modalPopupData && modalPopupData.image} alt="" />
        </div>
        <div className="Popup-content">
          <span>{modalPopupData && modalPopupData.title}</span>
          <p>{modalPopupData && modalPopupData.content}</p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => modalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => modalConfirm()}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>

      <AddNewGrade
        visible={NewGradeSideDrawer}
        addGrade={addGrade}
        closeGradeDrawer={setNewGradeSideDrawer}
        onClose={onCloseNewGrade}
        onCloseGrade={onCloseFullNewGrade}
        addNewGradeSuccess={addNewGradeSuccess}
        // showAlert={showNewGradeAlert}
      />

      {reelOrderSideDrawer && (
        <ReelOrderSpecDrawer
          visible={reelOrderSideDrawer}
          onClose={onCloseReelOrderDrawer}

          // showAlert={showNewGradeAlert}
        />
      )}

      {sheetOrderSideDrawer && (
        <SheetOrderSpecDrawer
          visible={sheetOrderSideDrawer}
          sheetSpecData={settings}
          roles={roles}
          onClose={onCloseSheetOrderDrawer}

          // showAlert={showNewGradeAlert}
        />
      )}

      {orderToleranceSideDrawer && (
        <OrderToleranceDrawer
          visible={orderToleranceSideDrawer}
          orderToleranceData={settings}
          onClose={onCloseOrderToleranceDrawer}
        />
      )}

      {newGrade && (
        <AddQuality
          visible={AddQualitySideDrawer}
          onClose={onCloseAddQuality}
          newGrade={newGrade}
          updateList={fetchSettings}
        />
      )}

      {EditDeleteGradeSideDrawer ? (
        <EditDeleteGrade
          grade={selectedGrade}
          visible={EditDeleteGradeSideDrawer}
          onClose={onCloseEditDeleteGrade}
          onCloseGrade={onCloseDeleteGrade}
          updateList={fetchSettings}
          roles={roles}
        />
      ) : (
        <></>
      )}
    </RightLayoutContainer>
  ) : (
    <></>
  );
};
export default ConfigGlobalSettings;
